import React, { useCallback, useEffect, useState } from "react";
import DataGridV2 from "../../components/DataGridV2";
import { INITIAL_ROW_SELECTION_MODEL } from "../../components/DataGridV2/constants";
import { getLocalStorageItem, groupBy, setLocalStorageItem } from "../../_helpers";
import { apps, LOCAL_STORAGE_GRID_KEYS, userAccountRoleConstants } from "../../_constants";
import { useTranslation } from "react-i18next";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import { useSelector } from "react-redux";
import { getProjectsInfoForOverview } from "../../apis/buyersGuideApis";
import { getAddRepairRequestProjectColumns } from "./addRepairRequestProjectUtils";

export default function ProjectSelectionGrid({
  onSelectProject,
}) {
const { t , i18n } = useTranslation();
const apiRef = useGridApiRef();
const { all = [], loading } = useSelector(state => state.buildings);
const app = useSelector((state) => state.app);
const [projects, setProjects] = useState([]);
const [projectsLoading, setProjectsLoading] = useState(true);
const keyPrefix = app === apps.constructionQuality ? "CONSTRUCTION_QUALITY" : "GENERAL";
const [rowSelectionModel, setRowSelectionModel] = useState( INITIAL_ROW_SELECTION_MODEL);
const [paginationModel, setPaginationModel] = useState(() =>
    getLocalStorageItem(
      LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_PROJECTS_PAGINATION[keyPrefix]
    )
  );

 useEffect(() => {
          setProjectsLoading(true);
          const projectsGroup = groupBy(all, "projectId");
          const REQUIRED_ROLE = userAccountRoleConstants.siteManager;
          const filteredProjectsGroup = Object.entries(projectsGroup).reduce(
          (acc, [projectId, buildings]) => {
            if (buildings.some(b => b.roles?.includes(REQUIRED_ROLE))) {
              acc[projectId] = buildings;
            }
            return acc;
          },
          {}
         );
          const projectIds = Object.keys(filteredProjectsGroup);
          if (!projectIds.length) {
          setProjects([]);
          setProjectsLoading(false);
          return;
        }
          getProjectsInfoForOverview(projectIds).then(({ data }) => {
              const projects = projectIds.map(pid => ({
              ...data.find(p => p.projectId === pid),
              id: pid,
              })).filter(Boolean);
  
              setProjects(projects);        
          }).finally(() => {
            setProjectsLoading(false);
        });
          
          
  
}, [all, loading, app]);

   
const columns = getAddRepairRequestProjectColumns({t,keyPrefix,i18n,apiRef})
  
const onPaginationModelChange = useCallback((newPaginationModel) => {
            setPaginationModel(newPaginationModel)
            setLocalStorageItem(
                LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_PROJECTS_PAGINATION[keyPrefix],
                newPaginationModel
            );
    }, [keyPrefix])

  return (
    <DataGridV2
      localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_PROJECTS_SEARCH_TEXT[keyPrefix]}
      localColumnFilterIdentifier={ LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_PROJECTS_COLUMN_FILTER[keyPrefix]}
      localColumnSortIdentifier={ LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_PROJECTS_COLUMN_SORT[keyPrefix]}
      localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_PROJECTS_COLUMN_ORDER[keyPrefix]}
      localColumnWidthIdentifier={ LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_PROJECTS_COLUMN_WIDTH[keyPrefix] }
      localColumnVisibilityIdentifier={ LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_PROJECTS_COLUMN_VISIBILITY[keyPrefix] }
      apiRef={apiRef}
      rows={projects}
      columns={columns}
      loading={loading || projectsLoading}
      pagination
      filterMode="client"
      {...(paginationModel && { paginationModel })}
      onPaginationModelChange={onPaginationModelChange}
      rowSelectionModel={rowSelectionModel}
      onRowSelectionModelChange={(newRowSelectionModel) => {
      setRowSelectionModel(newRowSelectionModel);
      }}
      onRowClick={(params) => {
        if (!loading) {
        const projectId = params?.row?.id;
        const projectData = projects.find((x) => x.id === projectId);    
        if (projectData) onSelectProject(projectData);
        }
      }}
      toolbarProps={{
        selectedRows: rowSelectionModel,
        title: t("general.projects"),
      }}
    
    />
  );
}
